import React, {useRef, useState} from 'react';
import {array, string, element, func, object, bool} from 'prop-types';
import getMetaTags from '../../util/getMetaTags';
import Error from "../Error";
import Table from "./Table";
import {useSearchInput} from '../../hooks/useSearchInput';
import ColumnSelector from "./ColumnSelector";
import DeletePopup from "../DeletePopup";

const Search = props => {
    const {
        headers,
        columnTypes,
        tableData,
        tableName,
        error,
        setError,
        initialSearchVal,
        showExport,
        showTemplate,
        showImport,
        showPrint,
    } = props;
    const inputFileRef = useRef();
    const {
        searchedData: currentData,
        setSearchedData: setCurrentData,
        searchVal,
        setSearchVal
    } = useSearchInput({
        endpoint: props.endpoint,
        searchData: tableData,
        initialSearchVal
    });
    const tags = getMetaTags();
    const [loading, setLoading] = useState({fetchInProgress: false});
    const [activeCols, setActiveCols] = useState([]);
    const [isPopupShown, setIsPopupShown] = useState(false);

    const importFn = (event) => {
        setLoading({fetchInProgress: true});
        event.preventDefault();
        const file = inputFileRef.current.files[0];
        const csrfToken = tags.filter((tag) => {
            return tag.name === "csrf-token"
        });
        if (!csrfToken || !csrfToken.length) {
            console.error('no csrf token');
            return;
        }

        const url = new URL(window.location.origin + props.endpoint + "import");
        const formData = new FormData();
        formData.set("_token", csrfToken[0].content);
        formData.set("file", file);
        const headers = new Headers({
            "X-Requested-With": "XMLHttpRequest",
            "X-CSRF-TOKEN": csrfToken[0].content
        });
        const request = new Request(url, {
            method: "POST",
            headers: headers,
            cache: "default",
            body: formData
        });
        fetch(request)
            .then(res => res.json())
            .then(result => {
                if (!result.error) {
                    setCurrentData(result.data);
                    setError((<Error errors={[result.message]}/>));
                } else {
                    setError((<Error errors={[result.message, ...result?.error_data]}/>));
                }
                setLoading({
                    fetchInProgress: false
                });
            });
    };

    const deleteSelectedColumns = () => {
        setLoading({fetchInProgress: true});
        const csrfToken = tags.filter((tag) => {
            return tag.name === "csrf-token"
        });
        if (!csrfToken || !csrfToken.length) {
            console.error('no csrf token');
            return;
        }

        const url = new URL(window.location.origin + props.endpoint + "delete");
        const formData = new FormData(document.getElementsByName('searchTable')[0]);
        formData.set("_token", csrfToken[0].content);
        var formObject = {};
        formData.forEach(function(value, key){
            formObject[key] = value;
        });
        var json = JSON.stringify(formObject);
        const headers = new Headers({
            "X-Requested-With": "XMLHttpRequest",
            "X-CSRF-TOKEN": csrfToken[0].content,
            "Content-Type": 'application/json'
        });
        const request = new Request(url, {
            method: "POST",
            headers: headers,
            cache: "default",
            body: json
        });
        fetch(request)
            .then(res => res.json())
            .then(result => {
                if (!result.error) {
                    setCurrentData(result);
                    setError((<Error errors={[result.message]}/>));
                } else {
                    setError((<Error errors={[result.message, ...result?.error_data]}/>));
                }
                setLoading({
                    fetchInProgress: false
                });
            });
    };

    return (
        <>
            {error}

            {loading.fetchInProgress ?
                <div className="loading"></div>

                : null
            }

            {props.children}

            {isPopupShown ? <DeletePopup onCancel={() => setIsPopupShown(false)} onConfirm={() => {
                deleteSelectedColumns();
                setIsPopupShown(false)
            }}/> : null}

            <div className="form__row form__row--align-baseline form__row--justify-space-between">
                <div>
                    <input onChange={(ev) => {
                        setSearchVal(ev.target.value)
                    }} value={searchVal} type="text" className="form__input form__input--single no-print"
                           placeholder="Search..."/>
                    <img src="/images/delete-grey.png" alt="delete button" className="search__delete-icon no-print"
                         onClick={() => {
                             setSearchVal('')
                         }}/>
                </div>
                <ColumnSelector headers={headers} setActiveCols={setActiveCols} page={tableName}/>
            </div>

            <form name={'searchTable'}>
                <Table setError={setError} endpoint={props.endpoint} endpointAppend={props.endpointAppend} searchVal={searchVal}
                       tableData={currentData} columnTypes={columnTypes} visibleColumns={activeCols} headers={headers} setCurrentData={setCurrentData}
                       auxColumns={props.auxColumns}/>
            </form>

            <div className="form__row form__row--justify-space-between no-print">
                <div className="form__row form__row--align-center">
                    {showExport ?
                        (<a className={"button button--dkblue-opaque form__button--export"}
                            href={props.endpoint + "export?search=" + searchVal}>
                            Export Data
                        </a>) : null}

                    {showTemplate ?
                        (<a href={props.endpoint + "export-template"}
                            className="button button--dkblue-white form__button--export">
                            Get Template
                        </a>) : null}

                    {showImport ?
                        (<form action="" method={'POST'} className={"form__button--export-form"}>
                            <label htmlFor="csv_upload" className="button button--dkblue-white form__button--export">Import
                                Data
                                <input type="file" name="csv_upload" id="csv_upload" ref={inputFileRef} onChange={importFn}
                                       className={"form__file-upload"}/>
                            </label>
                        </form>) : null}

                    {showPrint ?
                        (<a href="#" className="button button--orange-opaque form__button--export"
                            onClick={print => {
                                window.print();
                                return false;
                            }}>Print</a>) : null}
                </div>

                <button className={'button button--red-opaque form__button--delete'} onClick={() => setIsPopupShown(true)}>Delete</button>
            </div>
        </>
    );
};

Search.defaultProps = {
    visibleColumns: []
}

Search.propTypes = {
    headers: object,
    tableName: string,
    tableData: array,
    error: element,
    setError: func,
    auxColumns: array,
    initialSearchVal: string,
    showExport: bool,
    showTemplate: bool,
    showImport: bool,
    showPrint: bool,
    visibleColumns: array
};

export default Search;

//# sourceMappingURL=Search.js.map
